import { SiteList } from '../config';
import { getOriginBase } from './getOriginBase';
export var getClientPortalHost = function() {
    var _SiteList_flatMap_find;
    return getOriginBase() || ((_SiteList_flatMap_find = SiteList.flatMap(function(portal) {
        return portal.domains;
    }).find(function(domain) {
        return domain.authPortalUrl === window.location.origin;
    })) === null || _SiteList_flatMap_find === void 0 ? void 0 : _SiteList_flatMap_find.hostname) || '';
};
